import { ISettingsState } from '../../../Settings/Store/ISettingsState'
import { isDepositCheck } from './isDepositCheck'

/**
 * Decides whether a deposit applies based on the punch-card-aware deposit total
 * returned by the price-preview API, rather than the static per-activity deposit
 * stored in Redux. When a punch card covers the selected services the preview
 * reports a deposit of 0, so no deposit notice should be shown.
 */
export const isPreviewDeposit = (
  settings: ISettingsState,
  previewDeposit: number
): boolean => previewDeposit > 0 && isDepositCheck(settings, previewDeposit)
